export default __webpack_public_path__ + "static/media/mobile_home_edit_icon.85037612.svg";